import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Geolocation } from '../../../../models/geolocation.model';
import { BtnIconComponent } from '../../buttons/btn-icon/btn-icon.component';
import { ViewLocationComponent } from '../view-location/view-location.component';

@Component({
  selector: 'app-dlg-view-location',
  standalone: true,
  imports: [BtnIconComponent, ViewLocationComponent],
  templateUrl: './dlg-view-location.component.html',
  styleUrl: './dlg-view-location.component.css',
})
export class DlgViewLocationComponent implements OnInit, OnDestroy {
  readonly data = inject<any>(MAT_DIALOG_DATA);
  readonly dialogRef = inject(MatDialogRef<DlgViewLocationComponent>);

  location: Geolocation | undefined;

  constructor() {
    this.location = this.data?.location;
  }

  ngOnInit(): void {
    document.body.style.overflow = 'hidden';
  }

  ngOnDestroy(): void {
    document.body.style.overflow = 'auto';
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
